const e = (r) => (t) => {
  if (typeof t != "number")
    return "..";
  const n = r && t % 1 !== 0 ? 1 : 0;
  try {
    return t.toLocaleString(["nb", "nn"], {
      minimumFractionDigits: n,
      maximumFractionDigits: n
    });
  } catch {
    return t.toFixed(n);
  }
};
function o(r, t) {
  return +(Math.round(+`${r}e${t}`) + "e-" + String(t));
}
const i = (r) => typeof r == "number" && Number.isFinite(r);
export {
  e as createNumberFormatter,
  i as isNumber,
  o as round
};
//# sourceMappingURL=index.es8.js.map
